<template>
  <div v-if="!loading">
    <lcontainer>
      <lheader/>
      <hr class="mx-4 " />
      <div style="margin-top: 8%!important;">
        <div class="mt-5 pt-5"></div>
        <p class="main-tenant-color header ml-5 mt-10">
          Search For And Subscribe to Available Courses
        </p>
        <div class="mx-8 mt-4">
          <linput
            v-model="search"
            class="py-2"
            placeholder="Search by Course Name or Filter By Program Name"
          />
        </div>
        <div />
        <div class="flex flex-wrap">
          <course-card
            v-for="(course, i) in searchCourses"
            :key="i"
            :course="course"
            class=" flex"
          />
        </div>
        <div v-if="!searchCourses.length > 0">
          <empty message="No available courses " />
        </div>
      </div>
    </lcontainer>
  </div>
</template>
<script>
import SettingsMixin from "@/mixins/SettingsMixin";
import Empty from "../../components/general/Empty";
import { mapActions, mapGetters } from "vuex";

export default {
  mixins: [SettingsMixin],
  components: {
    Empty,
    CourseCard: () => import("@/components/learner/open-course-card"),
    LmsButton: () => import("@/components/general/button"),
    lcontainer: () => import("@/components/general/container"),
    LmsTable: () => import("@/components/admin/admin-table"),
    PageHeader: () => import("@/components/general/pageheader"),
    LmsSelect: () => import("@/components/forms/select"),
    linput: () => import("@/components/general/input"),
    lheader: () => import("@/components/shared/home/header"),
  },
  data() {
    return {
      form: {},
      error: {},
      search: "",
      loading:true,
      sort: [
        { text: "Name", value: "Name" },
        { text: "Email", value: "Email" },
      ],
      filter: [
        { text: "Tenants assigned to me", value: "Tenants assigned to me" },
        { text: "All Tenants", value: "All Tenants" },
      ],
    };
  },
  methods: {
    ...mapActions(["fetchExternalCourses"]),
  },
  computed: {
    ...mapGetters(["getExternalCourses"]),
    searchCourses() {
      if (!this.getExternalCourses) return;
      return this.getExternalCourses.filter((course) => {
        return (
          course.title.toLowerCase().match(this.search.toLowerCase()) ||
          course.program.toLowerCase().match(this.search.toLowerCase())
        );
      });
    },
  },
  async  mounted() {
    let prefix = new URL(this.getURI).host.split(".")[0]; //chnage url to window.location.href
    await this.fetchExternalCourses(prefix);
    this.loading = false
    //console.log({ prefix });
  },
};
</script>

<style scoped>
.header {
  margin-top: 0.65em !important;
  font-weight: bold !important;
  font-size: 19px !important;
  line-height: 28px !important;
  color: #080d33 !important;
}
</style>
